import React, { useState } from 'react'
import { useQuery } from 'react-query'
import { Typography, Grid } from '@the-platform-group/component-library'

// date formatters
import { startOfDay } from 'date-fns'
import { formatDate } from '@the-platform-group/formatters/dateFormat'
import { DATE_FORMAT } from '@the-platform-group/formatters/constants'

// filters
import { AsyncSelect } from '@the-platform-group/component-library/Select'
import { DatePicker } from '@the-platform-group/component-library'
import { debouncedLoadCustomers } from 'utils/optionsLoaders'

// services
import { getStatistics } from 'services/corporateConnect'

const defaultFilters = {
  customer: null,
  from: null,
  to: null,
}

const Statistics = () => {
  const [filters, setFilters] = useState(defaultFilters)

  const params = {
    customerId: filters.customer?.id,
    from: formatDate(filters.from, DATE_FORMAT),
    to: formatDate(filters.to, DATE_FORMAT),
  }

  const { data: stats } = useQuery({
    queryKey: ['corporateConnect', params],
    queryFn: () => getStatistics(params),
    initialData: { data: [] },
  })

  const handleCustomerSelect = customer => setFilters(prev => ({ ...prev, customer }))
  const handleDateChange = (date, field) =>
    setFilters(prev => ({ ...prev, [field]: startOfDay(date) }))

  const {
    totalOutreachCount = 'N/A',
    outreachToActivityCount = 'N/A',
    outreachToActivityRatio = 'N/A',
  } = stats.data[0] || {}
  return (
    <>
      <Typography variant="h4">Corporate Connect Statistics</Typography>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <AsyncSelect
            fullWidth
            hideArrow
            includeClearAll
            placeholder="Search for customer"
            value={filters.customer}
            onChange={handleCustomerSelect}
            optionsLoader={term => debouncedLoadCustomers({ state: 'active', term })}
          />
        </Grid>
        <Grid item xs={6} container>
          <DatePicker
            label="From"
            value={filters.from}
            variant="outlined"
            onChange={date => handleDateChange(date, 'from')}
          />
          <DatePicker
            label="To"
            value={filters.to}
            variant="outlined"
            onChange={date => handleDateChange(date, 'to')}
          />
        </Grid>
        <Grid item xs={12}>
          <>
            <Typography>{`Total Outreach Count: ${totalOutreachCount}`}</Typography>
            <Typography>{`Outreach to Activity Count: ${outreachToActivityCount}`}</Typography>
            <Typography>{`Outreach to Activity Ratio: ${outreachToActivityRatio}`}</Typography>
          </>
        </Grid>
      </Grid>
    </>
  )
}

export default Statistics
